import { Button as BSButton, Spinner } from "react-bootstrap";

const Button = ({ children, icon, loading, disabled, ...props }) => {
    return (
        <BSButton {...props} disabled={loading || disabled} className="d-flex align-items-center justify-content-center">
            {loading ? <Spinner animation="border" size="sm" className="me-2" /> : icon && <span className={`${children ? "me-1" : ""} d-flex align-items-center`}>{icon}</span>}
            {children}
        </BSButton>
    );
};

export default Button;
